export const SET_WORKSPACE = "SET_WORKSPACE";
export const LOAD_WORKSPACE = "LOAD_WORKSPACE";
export const LOAD_LIST = "LOAD_LIST";
export const SET_LIST = "SET_LIST";
export const SET_ERROR = "SET_ERROR";
export const SET_PUBLIC_FAN = "SET_PUBLIC_FAN";
export const LOAD_PUBLIC_FAN = "LOAD_PUBLIC_FAN";
export const LOAD_PUBLIC_FAN_ERROR = "LOAD_PUBLIC_FAN_ERROR";